export const DEFAULT_DECIMALS_PRECISION = 2;
export const DEFAULT_CURRENCY_TICKER = "USDC";

export default {
  DEFAULT_DECIMALS_PRECISION,
  DEFAULT_CURRENCY_TICKER,
};
